import { render, staticRenderFns } from "./Querystatistics.vue?vue&type=template&id=292f7287&scoped=true&"
import script from "./Querystatistics.vue?vue&type=script&lang=js&"
export * from "./Querystatistics.vue?vue&type=script&lang=js&"
import style0 from "./Querystatistics.vue?vue&type=style&index=0&id=292f7287&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292f7287",
  null
  
)

export default component.exports